// extracted by mini-css-extract-plugin
export default {"content":"Ysurf","title":"Zhn9X","description":"Wl5q0","store-links":"rVslW","icon-wrap":"vwUqM","icon-ios":"T5XEx","icon":"KSUFT"};